// extracted by mini-css-extract-plugin
module.exports = {"envFrame":"Environment_envFrame_3vR7v","cardTitle":"Environment_cardTitle_sMEmN"};